import { useMutation } from '@tanstack/react-query';
import { reservationsApi, CreateReservationDto } from '../services/api';

export const useCreateReservation = () => {
  return useMutation({
    mutationFn: (data: CreateReservationDto) => reservationsApi.create(data),
  });
};
